export default {
      id: "calculate-life-insurance-cover-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#calculate-life-insurance-cover",
      toString: function () {
        return this.url;
      }
    }